/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

import { WelcomeView } from './views/dialog/WelcomeView';
import { AdaptiveCardsView } from './views/adaptiveCards/AdaptiveCardsView';
import LftSidePaneView from './views/lft/LftSidePaneView';
import { LftTrialCountdownView } from './views/lft/LftTrialCountdownView';
import ExcelView from './views/trialConversion/ExcelView';
import { PowerpointView } from './views/trialConversion/PowerpointView';
import { WordView } from './views/trialConversion/WordView';
import { TrialBenefitsView } from './views/trialConversion/TrialBenefitsView';

/**
 * Configuration map for entry points.
 * To add a new entry point, simply add a new key-value pair here.
 */
export const entryPointConfig = {
  copilotLft: LftSidePaneView,
  welcome: WelcomeView,
  lftCountdown: LftTrialCountdownView,
  XLConversionTrials: ExcelView,
  WordConversionTrials: WordView,
  PPTConversionTrials: PowerpointView,
  adaptiveCards: AdaptiveCardsView,
  trialBenefits: TrialBenefitsView
} as const;

export type EntryPoint = keyof typeof entryPointConfig;
export const EntryPoints = Object.keys(entryPointConfig) as EntryPoint[];
